<template>
  <div
    class="row items-center no-wrap cursor-pointer tw-min-w-[220px] tw-max-w-full tw-gap-2 tw-rounded-xl tw-bg-black/5 tw-px-3 tw-py-2 tw-my-1 tw-transition hover:tw-bg-black/10"
    data-testid="chat-abrir-documento"
    @click="openAttach"
  >
    <div class="col-auto doc-icon">
      <component
        :is="attachIcon"
        viewBox="0 0 65 84"
      />
    </div>

    <div class="col tw-min-w-0">
      <div class="tw-truncate tw-text-[13px] tw-font-medium tw-text-foreground">
        {{ name }}
      </div>
      <div class="tw-text-[11px] tw-uppercase tw-text-gray-500">
        {{ extension }}
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/libs/api'
import { checkURL } from '@/libs/hasURL'
import IconCSS from '@/assets/icons/IconCSS.svg'
import IconDOC from '@/assets/icons/IconDOC.svg'
import IconJS from '@/assets/icons/IconJS.svg'
import IconODT from '@/assets/icons/IconODT.svg'
import IconPDF from '@/assets/icons/IconPDF.svg'
import IconPPT from '@/assets/icons/IconPPT.svg'
import IconSVG from '@/assets/icons/IconSVG.svg'
import IconTXT from '@/assets/icons/IconTXT.svg'
import IconXLS from '@/assets/icons/IconXLS.svg'
import IconXML from '@/assets/icons/IconXML.svg'
import IconZIP from '@/assets/icons/IconZIP.svg'
import IconUnknow from '@/assets/icons/IconUnknow.svg'
import ModalPDF from '@/components/ModalPDF'
const ipcRenderer = window.ipcRenderer

export default {
  components: {
    IconCSS,
    IconDOC,
    IconJS,
    IconODT,
    IconPDF,
    IconPPT,
    IconSVG,
    IconTXT,
    IconXLS,
    IconXML,
    IconZIP,
    IconUnknow
  },

  props: {
    url: {},
    name: {},
    direction: {}
  },

  data () {
    return {
      isLoading: true
    }
  },

  mounted () {
    this.isMounted = true
  },

  beforeDestroy () {
    this.isMounted = false
  },

  computed: {
    isPDF () {
      return this.attachIcon === 'IconPDF'
    },

    extension () {
      return String(this.name).split('.').pop().toUpperCase()
    },

    attachIcon () {
      const ext = String(this.name).split('.').pop().toLowerCase()

      if (ext === 'js') return 'IconJS'
      if (ext === 'pdf') return 'IconPDF'
      if (ext === 'ppt') return 'IconPPT'
      if (ext === 'doc') return 'IconDOC'
      if (ext === 'odt') return 'IconODT'
      if (ext === 'xml') return 'IconXML'
      if (ext === 'css') return 'IconCSS'
      if (ext === 'xls') return 'IconXLS'
      if (ext === 'svg') return 'IconSVG'
      if (ext === 'txt') return 'IconTXT'
      if (ext === 'zip') return 'IconZIP'

      if (ext === 'pdfx') return 'IconPDF'
      if (ext === 'docx') return 'IconDOC'
      if (ext === 'xlsx') return 'IconXLS'

      return 'IconUnknow'
    }
  },

  methods: {
    async openAttach () {
      const vm = this
      if (vm.isLoading) await checkURL(vm, vm.url)

      if (vm.isPDF) {
        if (this.direction === 'OUT') {
          const response = await fetch(vm.url)
          const { data } = await response.json()

          return vm.$q.dialog({ component: ModalPDF, parent: vm, url: data })
        }

        return vm.$q.dialog({ component: ModalPDF, parent: vm, url: vm.url })
      }

      const downloadUrl = await api.getDownloadUrl(vm.url)
      if (!downloadUrl) return

      ipcRenderer.send('download', {
        payload: {
          url: downloadUrl,
          name: vm.name
        }
      })
    }
  }
}
</script>

<style lang="sass" scoped>
.doc-icon
  width: 34px

  svg
    width: 100%
    height: auto
    display: block
</style>
